// Centralized image constants for the website
// All images are located in /public/assets/img/general/

// Complete list of all images in the general folder
const GENERAL_FOLDER_IMAGES = [
  '/assets/img/general/ai-generated-8685407_1280.jpg',
  '/assets/img/general/energy-2302001_1280.jpg',
  '/assets/img/general/photovoltaic-2814504_1280.jpg',
  '/assets/img/general/photovoltaic-4525178_1280.jpg',
  '/assets/img/general/photovoltaic-4541308_1280.jpg',
  '/assets/img/general/photovoltaic-system-2742302_1280.jpg',
  '/assets/img/general/pinwheels-6535595_1280.jpg',
  '/assets/img/general/solar-2376233_1280.jpg',
  '/assets/img/general/solar-6816101_1280.jpg',
  '/assets/img/general/solar-8244680_1280.jpg',
  '/assets/img/general/solar-cells-4518932_1280.jpg',
  '/assets/img/general/solar-energy-7882650_1280.jpg',
  '/assets/img/general/steptodown.com151755.jpg',
  '/assets/img/general/steptodown.com164145.jpg',
  '/assets/img/general/steptodown.com188081.jpg',
  '/assets/img/general/steptodown.com210838.jpg',
  '/assets/img/general/steptodown.com254434.jpg',
  '/assets/img/general/steptodown.com274154.jpg',
  '/assets/img/general/steptodown.com282280.jpg',
  '/assets/img/general/steptodown.com341684.jpg',
  '/assets/img/general/steptodown.com430799.jpg',
  '/assets/img/general/steptodown.com541656.jpg',
  '/assets/img/general/steptodown.com571771.jpg',
  '/assets/img/general/steptodown.com581415.jpg',
  '/assets/img/general/steptodown.com799996.jpg',
  '/assets/img/general/steptodown.com847305.jpg',
  '/assets/img/general/steptodown.com921453.jpg',
  '/assets/img/general/wind-power-generation-8370867_1280.jpg',
  '/assets/img/general/windmills-1838788_1280.jpg'
];

export const GENERAL_IMAGES = {
  // Solar Energy Images
  solar: {
    solar1: '/assets/img/general/solar-2376233_1280.jpg',
    solar2: '/assets/img/general/solar-6816101_1280.jpg',
    solar3: '/assets/img/general/solar-8244680_1280.jpg',
    solarCells: '/assets/img/general/solar-cells-4518932_1280.jpg',
    solarEnergy: '/assets/img/general/solar-energy-7882650_1280.jpg',
    photovoltaic1: '/assets/img/general/photovoltaic-2814504_1280.jpg',
    photovoltaic2: '/assets/img/general/photovoltaic-4525178_1280.jpg',
    photovoltaic3: '/assets/img/general/photovoltaic-4541308_1280.jpg',
    photovoltaicSystem: '/assets/img/general/photovoltaic-system-2742302_1280.jpg',
  },

  // Wind Energy Images
  wind: {
    windmills: '/assets/img/general/windmills-1838788_1280.jpg',
    windPower: '/assets/img/general/wind-power-generation-8370867_1280.jpg',
    pinwheels: '/assets/img/general/pinwheels-6535595_1280.jpg',
  },

  // General Energy Images
  energy: {
    energy1: '/assets/img/general/energy-2302001_1280.jpg',
    aiGenerated: '/assets/img/general/ai-generated-8685407_1280.jpg',
  },

  // Professional/Corporate Images
  professional: {
    corporate1: '/assets/img/general/steptodown.com151755.jpg',
    corporate2: '/assets/img/general/steptodown.com164145.jpg',
    corporate3: '/assets/img/general/steptodown.com188081.jpg',
    corporate4: '/assets/img/general/steptodown.com210838.jpg',
    corporate5: '/assets/img/general/steptodown.com254434.jpg',
    corporate6: '/assets/img/general/steptodown.com274154.jpg',
    corporate7: '/assets/img/general/steptodown.com282280.jpg',
    corporate8: '/assets/img/general/steptodown.com341684.jpg',
    corporate9: '/assets/img/general/steptodown.com430799.jpg',
    corporate10: '/assets/img/general/steptodown.com541656.jpg',
    corporate11: '/assets/img/general/steptodown.com571771.jpg',
    corporate12: '/assets/img/general/steptodown.com581415.jpg',
    corporate13: '/assets/img/general/steptodown.com799996.jpg',
    corporate14: '/assets/img/general/steptodown.com847305.jpg',
    corporate15: '/assets/img/general/steptodown.com921453.jpg',
  }
};

// Categorized image arrays for easy random selection
export const SOLAR_IMAGES = Object.values(GENERAL_IMAGES.solar);
export const WIND_IMAGES = Object.values(GENERAL_IMAGES.wind);
export const ENERGY_IMAGES = Object.values(GENERAL_IMAGES.energy);
export const PROFESSIONAL_IMAGES = Object.values(GENERAL_IMAGES.professional);

// All images combined
export const ALL_IMAGES = [
  ...SOLAR_IMAGES,
  ...WIND_IMAGES,
  ...ENERGY_IMAGES,
  ...PROFESSIONAL_IMAGES
];

// Dynamic image functions
export const getAllGeneralImages = () => GENERAL_FOLDER_IMAGES;

export const getShuffledGeneralImages = () => {
  const shuffled = [...GENERAL_FOLDER_IMAGES];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const getRandomGeneralImages = (count = 8) => {
  const shuffled = getShuffledGeneralImages();
  return shuffled.slice(0, count);
};

export const getCategorizedGeneralImages = (category = 'all') => {
  switch (category) {
    case 'solar':
      return GENERAL_IMAGES.solar;
    case 'wind':
      return GENERAL_IMAGES.wind;
    case 'energy':
      return GENERAL_IMAGES.energy;
    case 'professional':
      return GENERAL_IMAGES.professional;
    case 'all':
    default:
      return GENERAL_FOLDER_IMAGES;
  }
};

// Utility function to get random image from category
export const getRandomImage = (category = 'all') => {
  let images = ALL_IMAGES;
  
  switch (category) {
    case 'solar':
      images = SOLAR_IMAGES;
      break;
    case 'wind':
      images = WIND_IMAGES;
      break;
    case 'energy':
      images = ENERGY_IMAGES;
      break;
    case 'professional':
      images = PROFESSIONAL_IMAGES;
      break;
    default:
      images = ALL_IMAGES;
  }
  
  return images[Math.floor(Math.random() * images.length)];
};

// Utility function to get specific image by key
export const getImage = (category, key) => {
  return GENERAL_IMAGES[category]?.[key] || null;
};

// Predefined image sets for different use cases
export const IMAGE_SETS = {
  hero: {
    solar: GENERAL_IMAGES.solar.solarEnergy,
    wind: GENERAL_IMAGES.wind.windmills,
    energy: GENERAL_IMAGES.energy.energy1,
    corporate: GENERAL_IMAGES.professional.corporate1
  },
  news: {
    technology: GENERAL_IMAGES.energy.aiGenerated,
    solar: GENERAL_IMAGES.solar.photovoltaicSystem,
    wind: GENERAL_IMAGES.wind.windPower,
    general: GENERAL_IMAGES.professional.corporate2
  },
  projects: {
    solar: GENERAL_IMAGES.solar.solarCells,
    wind: GENERAL_IMAGES.wind.pinwheels,
    battery: GENERAL_IMAGES.energy.energy1,
    grid: GENERAL_IMAGES.professional.corporate3
  }
};
